import { render, staticRenderFns } from "./underPerfCrCharts.component.vue?vue&type=template&id=1d969d77&scoped=true&"
import script from "./underPerfCrCharts.component.vue?vue&type=script&lang=js&"
export * from "./underPerfCrCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./underPerfCrCharts.component.vue?vue&type=style&index=0&id=1d969d77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d969d77",
  null
  
)

export default component.exports